const styles = {
  root: {
    height: "0px",
    bottom: 0,
    top: "auto"
  }
};

export default styles;
